



















// Type Original is only defined in PHP; Vue components do not require it currently.

import Vue from "vue";
import {Pricing} from "../../module/Deals/view/vue/domain/Pricing";
import {PricingNote} from "../../module/Deals/view/vue/domain/PricingNote";
import { hideDiscounts } from "../helper/formula";

export default Vue.extend( {
  name     : 'Pricing',
  props    : {
    pricing : {
      type    : Object as () => Pricing | null,
      default : null
    },
    type : {
      type    : String,
      default : 'default'
    },
  },
  computed: {
    isSimple(): boolean {
      return this.type === 'simple';
    },
    showOriginalPrice(): boolean {
      return this.pricing?.hasOriginal?.() && !hideDiscounts();
    },
    note(): PricingNote {
      if (!this.pricing?.hasCurrent?.()) return null;
      const current = this.pricing.current;

      return this.isSimple
          ? (current.hasMultidealNote?.() ? (current.multidealNote as PricingNote) : null)
          : (current.hasNote?.() ? (current.note as PricingNote) : null);
    },

    hasNote(): boolean {
      return this.note !== null;
    }
  },
  methods: {
    openPriceModal(event: Event, price: string) {
      window.priceInformationModal(event, price);
    }
  }
} )
